import { User, Zap } from 'lucide-react'
import { Link } from 'react-router-dom'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { CopyButton } from '@/components/ui/copy-button'
import { TextWithTooltip } from '@/components/custom/text-with-tooltip'
import { formatPhoneForDisplay } from '@/utils/phone'
import type { MessageRecord } from '../types'

function ContextName({
  name,
  to,
  state,
}: {
  name: string
  to?: string
  state?: Record<string, unknown>
}) {
  return to ? (
    <Tooltip>
      <TooltipTrigger asChild>
        <Link
          to={to}
          state={state}
          className="hover:text-primary-high-contrast min-w-0 truncate hover:underline">
          {name}
        </Link>
      </TooltipTrigger>
      <TooltipContent>{name}</TooltipContent>
    </Tooltip>
  ) : (
    <TextWithTooltip text={name} className="min-w-0" />
  )
}

/** Same client/duty destinations and duty tab title state as the Calls sheet. */
export function MessageSheetContext({ message }: { message: MessageRecord }) {
  return (
    <div className="text-neutral-low-contrast flex min-w-0 flex-wrap items-center gap-x-3 gap-y-1 text-sm">
      <span className="flex min-w-0 items-center gap-1 font-mono">
        <TextWithTooltip text={message.id} className="max-w-[10ch]" />
        <CopyButton content={message.id} label="Copy Message ID" />
      </span>
      <span className="flex min-w-0 items-center gap-1">
        <User className="h-3.5 w-3.5 shrink-0" aria-hidden />
        <ContextName
          name={message.patient_name || 'Unknown client'}
          to={
            message.patient_name && message.patient_id
              ? `/data/patients?patients.id=${message.patient_id}&details=1`
              : undefined
          }
        />
      </span>
      {message.duty_name ? (
        <span className="flex min-w-0 items-center gap-1">
          <Zap className="h-3.5 w-3.5 shrink-0" aria-hidden />
          <ContextName
            name={message.duty_name}
            to={message.duty_id ? `/duties/${message.duty_id}` : undefined}
            state={
              message.duty_id ? { dutyName: message.duty_name } : undefined
            }
          />
        </span>
      ) : null}
      <span className="shrink-0">{formatPhoneForDisplay(message.phone)}</span>
    </div>
  )
}
